import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import './output.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Elemento com ID "root" não encontrado no DOM. A aplicação React não pode ser inicializada.');
}

const root = createRoot(rootElement);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);